import { createEntityAdapter } from "@reduxjs/toolkit";

import Site from "types/Site";

export const sitesAdapter = createEntityAdapter<Site>({
    sortComparer: (a, b) => a.id.localeCompare(b.id),
});
